import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {MissionBannerType} from '../utils/missionType';
import {useGetActiveMissions} from '../utils/useGetActiveMissions';
import {MissionBannerView} from './MissionBannerView';

export const MissionBanner: React.FC<{
  className?: string;
  bannerType: MissionBannerType;
}> = ({className, bannerType}) => {
  return (
    <DataFetcher
      request={useGetActiveMissions()}
      Error={null}
      View={MissionBannerView}
      Loading={() => null}
      viewProps={{className, bannerType}}
    />
  );
};
